var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluefilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1F453404-6100-4C8C-894D-B7D42EF63866") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RiseIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recruiters",
    transform: "translate(-1477.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1680,
    height: 1066
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 223,
    y: 0,
    width: 1457,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "blue-bg",
    stroke: "#D7D7D7",
    x: 1463,
    y: 6,
    width: 48,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(1477.000000, 21.000000)",
    fill: "#0262B9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 4.44444444,
    rx: 2.22222222
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.33333333,
    y: 6.66666667,
    width: 13.3333333,
    height: 4.44444444,
    rx: 2.22222222
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.66666667,
    y: 13.3333333,
    width: 6.66666667,
    height: 4.44444444,
    rx: 2.22222222
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluefilter);
export default __webpack_public_path__ + "static/media/bluefilter.c432310b88ffe80e0546254f3bca0647.svg";
export { ForwardRef as ReactComponent };